import { normalize } from 'normalizr';

import { request } from 'utils';

import { getProductsIds } from 'selectors';

import {
  FETCH_FOREX_COMPANIES_REQUEST,
  FETCH_FOREX_COMPANIES_SUCCESS,
  FETCH_FOREX_COMPANIES_FAILURE,
} from 'actionTypes';

import { companies as companiesSchema } from 'schemas';

export const getFormattedProductsIds = async getState => {
  const state = getState();
  const productIds = await getProductsIds(state);

  if (Array.isArray(productIds) && !productIds.length) {
    throw new Error('No ids for selected currency');
  }

  return `id[]=${productIds?.join('&id[]=')}`;
};

const getCompaniesWithFinanceId = companies =>
  companies.filter(company => {
    return !!company.financeId && parseInt(company.financeId, 10) !== 0;
  });

export const fetchForexCompanies = props => async (dispatch, getState) => {
  try {
    dispatch({
      type: FETCH_FOREX_COMPANIES_REQUEST,
      payload: {},
    });
    const productIds = await getFormattedProductsIds(getState, props);

    const { data } = await request({
      url: `${process.env.APP_COMPANIES_API_ROOT}?locale=${props.intl.locale}&${productIds}}`,
      params: {},
    });

    const {
      entities: { companies: entities = {} },
      result: ids = [],
    } = normalize(getCompaniesWithFinanceId(data), companiesSchema);

    return dispatch({
      type: FETCH_FOREX_COMPANIES_SUCCESS,
      payload: {
        entities,
        ids,
      },
    });
  } catch (error) {
    return dispatch({
      type: FETCH_FOREX_COMPANIES_FAILURE,
      payload: {},
    });
  }
};
